import { useEffect } from "react";
import usePosOrderResetHook from "@/shared/hooks/usePosOrderResetHook";

const PosGlobalReset = () => {
  const reset = usePosOrderResetHook();
  useEffect(() => {
    return () => reset();
  }, []);

  return null;
};

export default PosGlobalReset;
